import { getSessionIdSync } from './getSessionId';

const { VITE_BASE_API_URL } = import.meta.env;

/**
 * Enhanced fetch wrapper that automatically adds sessionId and common headers
 */
export const apiClient = async (endpoint: string, options: RequestInit = {}): Promise<Response> => {
  const sessionId = getSessionIdSync();

  const defaultHeaders: HeadersInit = {
    'content-type': 'application/json',
    traceparent: '8bdf037f-6e84-495d-b7b6-1454679501c2',
    'x-date-override': '2025-11-18T14:36:28.100Z',
    'x-interaction-id': 'e0d258b0-ea59-4b4a-ad83-6cd71f8778b0',
    'x-recaptcha-token': 'some-token',
  };

  // Add sessionId header if available
  if (sessionId) {
    (defaultHeaders as Record<string, string>)['x-session-id'] = sessionId.id;
  }

  const mergedHeaders = {
    ...defaultHeaders,
    ...options.headers,
  };

  const response = await fetch(`${VITE_BASE_API_URL}${endpoint}`, {
    ...options,
    headers: mergedHeaders,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

export const get = async <T>(endpoint: string): Promise<T> => {
  const response = await apiClient(endpoint, { method: 'GET' });
  return response.json() as Promise<T>;
};

export const post = async <T>(endpoint: string, body?: unknown): Promise<T> => {
  const response = await apiClient(endpoint, {
    method: 'POST',
    body: body ? JSON.stringify(body) : undefined,
  });
  return response.json() as Promise<T>;
};
